import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import {
  TRACK_USER_ACTION_EVENT,
  trackUserAction,
} from '@/utilities/logger/amplitude/tracking';

const SERVICE = 'showoff';

export const trackShowoffViewed = () => {
  Logger.logRumAction({
    name: 'In Game Notification Viewed',
    description: 'Showoff feature notification was viewed by the user',
    useCase: DdEventCategory.UserInteraction,
    eventType: DdEventType.Action,
    service: SERVICE,
    payload: { module: 'feature_notification' },
  });
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_NOTIFICATION_VIEWED,
  });
};

export const trackShowoffSelected = () => {
  Logger.logRumAction({
    name: 'In Game Notification Selected',
    description: 'User clicked Check it out on a showoff notification',
    useCase: DdEventCategory.UserInteraction,
    eventType: DdEventType.Action,
    service: SERVICE,
    payload: { module: 'feature_notification' },
  });
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_NOTIFICATION_SELECTED,
  });
};

export const trackShowoffClosed = () => {
  Logger.logRumAction({
    name: 'In Game Notification Closed',
    description: 'User dismissed a showoff notification',
    useCase: DdEventCategory.UserInteraction,
    eventType: DdEventType.Action,
    service: SERVICE,
    payload: { module: 'feature_notification' },
  });
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_NOTIFICATION_CLOSED,
  });
};
